export function DevAgentReauthModal({
  open,
  onDismiss,
}: {
  open: boolean;
  onDismiss: () => void;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-background border border-border rounded-xl shadow-2xl p-6 max-w-md w-full mx-4">
        <h2 className="text-lg font-semibold mb-2">Salesforce Session Expired</h2>
        <p className="text-sm text-muted-foreground mb-5">
          Your Salesforce session has expired. Please reconnect your org to
          continue working.
        </p>
        <div className="flex gap-2 justify-end">
          <button
            type="button"
            onClick={onDismiss}
            className="px-3 py-1.5 text-sm rounded-lg border border-border hover:bg-muted/50 transition-colors"
          >
            Dismiss
          </button>
          <button
            type="button"
            onClick={() => {
              onDismiss();
              window.location.href = "/org/connection";
            }}
            className="px-3 py-1.5 text-sm rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            Reconnect Org
          </button>
        </div>
      </div>
    </div>
  );
}
